module.exports = __webpack_public_path__ + "img/unique@2x.44d3430.webp";